import React, { useEffect, useState } from 'react';
import { useBlocker, useNavigate, useLocation } from 'react-router-dom';

import ConfirmationDialog from '../Form/ConfirmationDialog';

const CommonNavigationPrompt = ({
    when,
    bodyText = 'You have unsaved changes. Do you want to leave and discard your changes?',
    submitLabel = 'Yes',
    cancelLabel = 'No',
    customOnConfirm,
    customOnSubmit,
  }) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [location, setLocation] = useState(currentLocation);

  useEffect(() => {
    if (!when && isOpen) {
      setIsOpen(false);
    }

    const closeHandle = (event) => {
      if (when) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', closeHandle);

    return () => {
      window.removeEventListener('beforeunload', closeHandle);
    };
  }, [when]);

  const shouldBlock = React.useCallback(
    ({ currentLocation, nextLocation }) => {
        if (when) {
          if (
            (!location || nextLocation.pathname !== location.pathname)
            && currentLocation.pathname !== nextLocation.pathname
          ) {
            setLocation(nextLocation);
            setIsOpen(true);

            return true;
          }
        }

        return false;
    },
    [when]
  );

  const blocker = useBlocker(shouldBlock);

  const submitHandler = () => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
    customOnConfirm && customOnConfirm();
    navigate(location.pathname, { replace: true });
    setIsOpen(false);
  };

  const cancelHandler = () => {
    customOnSubmit && customOnSubmit();
    setIsOpen(false);
  };

  return (
    <ConfirmationDialog
      open={isOpen}
      bodyText={bodyText}
      submitLabel={submitLabel}
      cancelLabel={cancelLabel}
      onSubmit={submitHandler}
      onCancel={cancelHandler}
    />
  );
};

export default CommonNavigationPrompt;
